import React, {useCallback, useEffect, useState} from "react";
import FileCard from "./FileCard";
import AddModal from "./AddModal";
import ImageUpload from "./ImageUpload";
import {header} from "../../Components/Url/ApiUrl";
import {Logout} from "../../Components/Actions/Actions";
import swal from "sweetalert";
import CompanyServiceTextEditModal from "./CompanyServiceTextEditModal";
import {useTranslation} from "react-i18next";

const CompanyServices = ({user, regions}) => {
    const {t} = useTranslation();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [hududlar, setHududlar] = useState([])
    const [model, setModel] = useState({})
    const [showTextEdit, setShowTextEdit] = useState(false)


    const handleFetch = useCallback(async () => {
        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/company/company-services`, {
                method: "GET",
                headers: header,
            });
            if (response.status === 401) {
                Logout();
                return;
            }
            if (!response.ok) {
                throw new Error(t('translation:no_data_found'));
            }
            const companyData = await response.json();
            setData(companyData);
            if(companyData.hududlar){
                setHududlar(companyData.hududlar)
            }
            setModel(companyData.model)
        } catch (error) {
            console.error('Company fetch xatosi:', error);
            swal(t('error'), error.message || t('translation:unknown_error'), "error");
        } finally {
            setLoading(false);
        }
    }, [t]);

    useEffect(() => {
        handleFetch();
    }, [handleFetch]);

    const toggleEditText = ()=>{
        setShowTextEdit(true);
    }
    const handleCancel = () => {
        setShowTextEdit(false);
    }

    if (loading) {
        return <div className="loading-spinner">{t('loading')}</div>;
    }

    if (!data) {
        return <div>{t('translation:error_occured')}</div>;
    }

    return (
        <div className="company-service-view container-fluid">
            <h3 className="py-3">{t('sales_outlets_service_centers')}</h3>
            <section>
                <p><b>{t('which_region')}</b></p>
                <small><i>{t('upload_cadastral_document')}</i></small>

                <div className="d-flex align-items-center mt-2">
                    {
                        hududlar ?
                            hududlar.map((h,k)=>{
                                return <FileCard
                                    key={k}
                                    region={regions?regions.find(e => e.id === h.region)?.name_l:''}
                                    type={h.type}
                                    token={h.shartnoma}
                                    id={h.id}
                                    handleFetch={handleFetch}
                                />
                            })
                            :null
                    }
                    {
                        user.can_update?
                            <AddModal
                                regions={regions}
                                onSuccess={handleFetch}
                            />
                            : null
                    }
                </div>
            </section>

            <hr/>

            <section className="row">
                <div className="col-auto d-flex align-items-center">
                    {
                        user.can_update ?
                            <>
                                <button
                                    className="btn btn-rounded btn-outline-primary p-0"
                                    style={{width: "32px", height: "32px"}}
                                    onClick={toggleEditText}
                                >
                                    <i className="bi bi-pencil-fill"></i>
                                </button>
                                <CompanyServiceTextEditModal
                                    show={showTextEdit}
                                    handleClose={handleCancel}
                                    model={model}
                                    onSuccess={handleFetch}
                                />
                            </>

                            : null
                    }
                </div>
                <div className="col">
                    <b>{t('about_service_center')}</b>
                    <p><i>{model.hududlar_web || t('info_not_inserted')}</i></p>
                    <b>{t('accesory_store')}:</b>
                    <p><i>{model.additional_info || t('info_not_inserted')}</i></p>
                </div>
            </section>

            <hr/>

            <section>
                <b>{t('sales_outlet_gallry')}</b>
                {Boolean(user.can_update) && (
                    <ImageUpload/>
                )}
            </section>
        </div>
    )
}
export default CompanyServices;